export enum Iso3166CountryType {
  None = 0,
  DE = 1,
  AT = 2,
  CH = 3,
  NL = 4,
  BE = 5,
  FR = 6,
  PL = 7,
  SI = 8,
  RS = 9,
  HR = 10,
  EG = 11,
  TR = 12,
  AD = 13,
  AE = 14,
  AF = 15,
  AG = 16,
  AL = 17,
  AM = 18,
  AO = 19,
  AR = 20,
  AU = 21,
  AW = 22,
  AZ = 23,
  BA = 24,
  BB = 25,
  BD = 26,
  BF = 27,
  BG = 28,
  BH = 29,
  BI = 30,
  BJ = 31,
  BL = 32,
  BM = 33,
  BN = 34,
  BO = 35,
  BR = 36,
  BS = 37,
  BT = 38,
  BW = 39,
  BY = 40,
  BZ = 41,
  CA = 42,
  CD = 43,
  CF = 44,
  CG = 45,
  CI = 46,
  CL = 47,
  CM = 48,
  CN = 49,
  CO = 50,
  CR = 51,
  CU = 52,
  CV = 53,
  CY = 54,
  CZ = 55,
  DJ = 56,
  DK = 57,
  DM = 58,
  DO = 59,
  DZ = 60,
  EC = 61,
  EE = 62,
  EH = 63,
  ER = 64,
  ES = 65,
  ET = 66,
  FI = 67,
  FJ = 68,
  FK = 69,
  FM = 70,
  FO = 71,
  GA = 72,
  GB = 73,
  GD = 74,
  GE = 75,
  GF = 76,
  GG = 77,
  GH = 78,
  GI = 79,
  GL = 80,
  GM = 81,
  GN = 82,
  GP = 83,
  GQ = 84,
  GR = 85,
  GT = 86,
  GW = 87,
  GY = 88,
  HK = 89,
  HN = 90,
  HT = 91,
  HU = 92,
  ID = 93,
  IE = 94,
  IL = 95,
  IM = 96,
  IN = 97,
  IQ = 98,
  IR = 99,
  IS = 100,
  IT = 101,
  JE = 102,
  JM = 103,
  JO = 104,
  JP = 105,
  KE = 106,
  KG = 107,
  KH = 108,
  KI = 109,
  KM = 110,
  KN = 111,
  KP = 112,
  KR = 113,
  XK = 114,
  KW = 115,
  KY = 116,
  KZ = 117,
  LA = 118,
  LB = 119,
  LC = 120,
  LI = 121,
  LK = 122,
  LR = 123,
  LS = 124,
  LT = 125,
  LU = 126,
  LV = 127,
  LY = 128,
  MA = 129,
  MC = 130,
  MD = 131,
  ME = 132,
  MF = 133,
  MG = 134,
  MH = 135,
  MK = 136,
  ML = 137,
  MM = 138,
  MN = 139,
  MO = 140,
  MQ = 141,
  MR = 142,
  MT = 143,
  MU = 144,
  MV = 145,
  MW = 146,
  MX = 147,
  MY = 148,
  MZ = 149,
  NA = 150,
  NC = 151,
  NE = 152,
  NG = 153,
  NI = 154,
  NO = 155,
  NP = 156,
  NR = 157,
  NZ = 158,
  OM = 159,
  PA = 160,
  PE = 161,
  PF = 162,
  PG = 163,
  PH = 164,
  PK = 165,
  PM = 166,
  PR = 167,
  PT = 168,
  PW = 169,
  PY = 170,
  QA = 171,
  RE = 172,
  RO = 173,
  RU = 174,
  RW = 175,
  SA = 176,
  SC = 177,
  SD = 178,
  SE = 179,
  SG = 180,
  SJ = 181,
  SK = 182,
  SL = 183,
  SM = 184,
  SN = 185,
  SO = 186,
  SR = 187,
  ST = 188,
  SV = 189,
  SY = 190,
  SZ = 191,
  TC = 192,
  TD = 193,
  TG = 194,
  TH = 195,
  TJ = 196,
  TL = 197,
  TM = 198,
  TN = 199,
  TO = 200,
  TT = 201,
  TV = 202,
  TW = 203,
  TZ = 204,
  UA = 205,
  UG = 206,
  US = 207,
  UY = 208,
  UZ = 209,
  VA = 210,
  VC = 211,
  VE = 212,
  VG = 213,
  VN = 214,
  VU = 215,
  WF = 216,
  WS = 217,
  YE = 218,
  YT = 219,
  ZA = 220,
  ZM = 221,
  ZW = 222,
  WB = 223,
  GS = 224,
  GO = 225,
  RER = 226,
}
